import React from 'react';
import * as S from './listing-section.styles';
import getListWithNewTitle from '@stencil/flights-utils/src/get-list-with-new-title';

import BreadCrumbs from '@stencil/commonstories/src/components/Seo/breadcrumbs/breadcrumbs';
import Faqs from '@stencil/commonstories/src/components/Seo/faqs/faq-section';
import AboutCityCountry from '@stencil/commonstories/src/components/Seo/about-city/about-city-country';
import LinksBlock from '@stencil/commonstories/src/components/Seo/list-for-links/list-for-links-city-country';

const Footer = ({ footerData }) => {
  const {
    srcName,
    destName,
    breadcrumb,
    faqs,
    aboutCity,
    aboutCountry,
    fromSourceCityLinks,
    topCountriesLinkedData,
    sourceLinkedData,
    withinCountryCityLinks,
    toSourceCityLinks
  } = footerData;

  return (
    <>
      <BreadCrumbs breadcrumb={breadcrumb} isCityCountry={true} />
      <S.ListingOuter>
        {faqs && faqs.length ? <Faqs faqs={faqs} isDweb={true} /> : null}
        {aboutCity ? (
          <AboutCityCountry
            heading={`ABOUT ${srcName?.toUpperCase()}`}
            color="contentDarkBlue"
            aboutInfo={aboutCity}
            isDweb={true}
          />
        ) : null}
        {aboutCountry ? (
          <AboutCityCountry
            heading={`ABOUT ${destName?.toUpperCase()}`}
            color="contentBrown"
            aboutInfo={aboutCountry}
            isDweb={true}
          />
        ) : null}
      </S.ListingOuter>
      <S.ListingOuter>
        {fromSourceCityLinks && fromSourceCityLinks.length > 0 ? (
          <LinksBlock
            title={`Top Flights From ${srcName}`}
            links={getListWithNewTitle(fromSourceCityLinks, `${srcName} To %s Flights`)}
            isDweb={true}
          />
        ) : null}
        {topCountriesLinkedData && topCountriesLinkedData.length > 0 ? (
          <LinksBlock
            title={`Flights To Top Countries`}
            links={getListWithNewTitle(topCountriesLinkedData, `%s Flights`)}
            isDweb={true}
          />
        ) : null}
        {sourceLinkedData && sourceLinkedData.length > 0 ? (
          <LinksBlock
            title={`Top Destinations`}
            links={getListWithNewTitle(sourceLinkedData, `${srcName} To %s Flights`)}
            isDweb={true}
          />
        ) : null}
        {withinCountryCityLinks && withinCountryCityLinks.length > 0 ? (
          <LinksBlock
            title={`Flights in ${destName}`}
            links={withinCountryCityLinks}
            isDweb={true}
          />
        ) : null}
        {toSourceCityLinks && toSourceCityLinks.length > 0 ? (
          <LinksBlock
            title={`Top Flights To ${srcName}`}
            links={getListWithNewTitle(toSourceCityLinks, `%s To ${srcName} Flights`)}
            isDweb={true}
          />
        ) : null}
      </S.ListingOuter>
    </>
  );
};
export default Footer;
